/**
 * Created by Rishabh Kumar on 03-08-2018
 * */

import * as React from "react"
import * as _ from "lodash";
import { IMedicationInfo } from "@curefit/ehr-common";
import TextInput from "../TextInput"
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import IMedicineSuggestions from "../../models/IMedicineSuggestions";
import DurationComponent from "../DurationComponent";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import ModelFactory from "../../models/ModelFactory";

export interface ConditionItemEditorProps {
    item: IMedicationInfo;
    onDataChange: (update: any) => any;
    showRelationshipDropdown: boolean;
    disableFields?: boolean;
    fetchMedicineByGenericName: (name: string) => Promise<IMedicineSuggestions[]>;
}

class PsychiatricHistoryRepeatItemEditor extends React.Component<ConditionItemEditorProps> {
    onCommentChange = (evt: any) => {
        let comments = evt.target.value;
        this.props.onDataChange({ ...this.props.item, comments })
    };

    onMedicineTypeAheadChange = (input: string) => {
        let updatedItem = { ...this.props.item, medicineName: input };
        this.props.onDataChange(updatedItem);
        return this.props.fetchMedicineByGenericName(input.toUpperCase()).then(medicines => {
            let medicineTypeAhead: TypeAheadElement[] = [];
            _.map(medicines, (medicine) => {
                let typeAheadElement: TypeAheadElement = {
                    value: medicine.uCode,
                    label: medicine.productName,
                    additionalInfoLabel: `${medicine.molecule} | ${medicine.dosageForm} | ${medicine.strength}`,
                    others: {
                        dosage: medicine.strength,
                        genericName: medicine.molecule,
                        type: medicine.dosageForm,
                        available: medicine.expectedInCareFitPharmacy
                    }
                }
                medicineTypeAhead.push(typeAheadElement);
            })
            return Promise.resolve({options: medicineTypeAhead, completed: true});
        }).catch(error => {
            throw error;
        });
    };

    onMedicineTypeAheadSelect = (element: TypeAheadElement) => {
        let updatedItem = {...this.props.item, medicineName: element.label};
        this.props.onDataChange(updatedItem);
    };

    generateMedicineFrequencyList = () => {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        });
        return frequencyList;
    };

    onFrequencyCountChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        let medicineFrequency = this.props.item.frequency !== null ? this.props.item.frequency : ModelFactory.createNewMedicineFrequency();
        let medicineFrequencyType = _.isEmpty(medicineFrequency.unit) ? null : medicineFrequency.unit;
        let repeatCount =  isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        medicineFrequency = { ...medicineFrequency, count: repeatCount, unit: medicineFrequencyType};
        let updatedItem = { ...this.props.item, frequency: medicineFrequency };
        this.props.onDataChange(updatedItem);
    };

    onFrequencyUnitChange = (value: string): void => {
        let medicineFrequency = this.props.item.frequency !== null ? this.props.item.frequency : ModelFactory.createNewMedicineFrequency();
        medicineFrequency = { ...medicineFrequency, unit: value };
        let updatedItem = { ...this.props.item, frequency: medicineFrequency };
        this.props.onDataChange(updatedItem);
    };

    onFrequencyChange = (elem: TypeAheadElement) => {
        let medicineFrequency = elem.others.value;
        let updatedItem = { ...this.props.item, frequency: medicineFrequency };
        this.props.onDataChange(updatedItem);
    };

    onDurationCountChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        let medicineDuration = this.props.item.duration !== null ? this.props.item.duration : ModelFactory.createNewMedicineDuration();
        let medicineDurationType = _.isEmpty(medicineDuration.unit) ? null : medicineDuration.unit;
        let repeatCount =  isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        medicineDuration = { ...medicineDuration, count: repeatCount, unit: medicineDurationType};
        let updatedItem = { ...this.props.item, duration: medicineDuration };
        this.props.onDataChange(updatedItem);
    };

    onDurationUnitChange = (value: string): void => {
        let medicineDuration = this.props.item.duration !== null ? this.props.item.duration : ModelFactory.createNewMedicineDuration();
        medicineDuration = { ...medicineDuration, unit: value };
        let updatedItem = { ...this.props.item, duration: medicineDuration };
        this.props.onDataChange(updatedItem);
    };

    onDurationChange = (elem: TypeAheadElement) => {
        let medicineDuration = elem.others.value;
        let updatedItem = { ...this.props.item, duration: medicineDuration };
        this.props.onDataChange(updatedItem);
    };

    render () {
        let comments = this.props.item.comments;
        let medicineFrequencyUnit = this.props.item.frequency !== null ? this.props.item.frequency.unit : null;
        let medicineFrequencyCount = this.props.item.frequency !== null && this.props.item.frequency.count !== undefined && this.props.item.frequency.count !== null ? this.props.item.frequency.count : null;
        let medicineDurationUnit = this.props.item.duration !== null ? this.props.item.duration.unit : null;
        let medicineDurationCount = this.props.item.duration !== null && this.props.item.duration.count !== undefined && this.props.item.duration.count !== null ? this.props.item.duration.count : null;
        return (
            <div className={"psychiatric-repeat-items-wrapper in-blk"}>
                <div className={"psychiatric-history-medication in-blk psychiatric-field"}>
                    <TypeAhead widgetName={"PsychiatricHistoryRepeatItem"} name={"medication"} value={this.props.item.medicineName || ""} placeholder={AppPlaceholders.NAME} onTypeAheadChange={this.onMedicineTypeAheadChange} onTypeAheadSelect={this.onMedicineTypeAheadSelect}/>
                </div>
                <div className={"psychiatric-history-frequency in-blk psychiatric-field"}>
                    <DurationComponent isFrequency={true} unit={medicineFrequencyUnit} count={medicineFrequencyCount} dropdownItems={this.generateMedicineFrequencyList()} rootClass={"medication-frequency"} onCountChange={this.onFrequencyCountChange} onUnitChange={this.onFrequencyUnitChange} onDurationChange={this.onFrequencyChange} />
                </div>
                <div className={"psychiatric-history-duration in-blk psychiatric-field"}>
                    <DurationComponent unit={medicineDurationUnit} count={medicineDurationCount} dropdownItems={this.generateMedicineFrequencyList()} rootClass={"medication-frequency"} onCountChange={this.onDurationCountChange} onUnitChange={this.onDurationUnitChange} onDurationChange={this.onDurationChange} />
                </div>
                <div className={"psychiatric-history-comments psychiatric-field in-blk"}>
                    <TextInput name={"comments-input"} placeholder={AppPlaceholders.SURGERIES_EDITVIEW_COMMENTS} onChange={this.onCommentChange} value={comments}/>
                </div>
            </div>
        )
    }
}

export default PsychiatricHistoryRepeatItemEditor